export default __webpack_public_path__ + "static/logo-oak-09ebfe4efb5165544dd923943294e1b9.png";